var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalTaskIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0837402 0.570312H6.08374V4.57031H0.0837402V0.570312ZM12.0837 7.57031H18.0837V11.5703H12.0837V7.57031ZM12.0837 14.5703H18.0837V18.5703H12.0837V14.5703ZM10.0837 10.5703H4.08374V15.5703H10.0837V17.5703H4.08374H2.08374V6.57031H4.08374V8.57031H10.0837V10.5703Z",
    fill: "#13343B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalTaskIcon);
export default __webpack_public_path__ + "static/media/total_task_icon.40fae8b3bcb130a2251a1785d6b06a4b.svg";
export { ForwardRef as ReactComponent };